// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useMemo, Fragment} from 'react';
import {use_theme} from '../settings_ctx';
import {Cards, i_cls_obj} from '../ui/cards';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './about_media_banner.module.less';

interface i_about_media_props {
    title?: string;
    subtitle?: string;
}

export const About_media = (props: i_about_media_props)=>{
    const {title = 'More Hola?',
          subtitle = 'Check out what folks are saying about us'} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const media_cards = useMemo(()=>{
        const ids = ['press', 'media', 'blog'];
        const data = {
            press: {
                title: 'Press kit',
                text: <Fragment>Get Hola's branding<br/>assets</Fragment>,
                btn: {
                    to: '/static/press_kit/press_kit.zip',
                    clickid: 'about_us_media_block_press',
                    round: true,
                    caption: 'Download archive',
                    color: 'transparent',
                    as_external: true,
                },
            },
            media: {
                title: 'Hola in the media',
                text: <Fragment>Lights, camera, action<br/>
                    (and some cool articles too)</Fragment>,
                btn: {
                    to: '/media',
                    clickid: 'about_us_media_block_media',
                    round: true,
                    caption: 'Read articles',
                    color: 'transparent',
                },
            },
            blog: {
                title: 'Hola blog',
                text: 'Hear about what we\'ve got going on',
                btn: {
                    to: '/blog',
                    clickid: 'about_us_media_block_blog',
                    round: true,
                    caption: 'Go to Blog',
                    color: 'transparent',
                },
            },
        };
        return ids.map(id=>({
            id,
            img: `about/${id}.svg`,
            clickid: `about_us_media_card_${id}`,
            ...data[id],
        }));
    }, []);
    const cls: i_cls_obj = {
        container: styles.media_cards_container,
        card: styles.media_card,
        title: cn(theme.p1, styles.media_card_title),
        text: cn(theme.p2, styles.media_card_text),
    };
    return <section className={styles.media_section}>
        <p className={cn(theme.p1, styles.title_p)}>{title}</p>
        <h3 className={cn(theme.h3, styles.media_h3)}>{subtitle}</h3>
        <Cards cards={media_cards} cls={cls}/>
    </section>;
};

interface i_about_media_editor_props {
    value: i_about_media_props;
    on_change: (new_val: i_about_media_props)=>void;
}

export const About_media_editor = (
{value, on_change}: i_about_media_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[
      {key: 'title', label: 'Title (small)', type: 'text'},
      {key: 'subtitle', label: 'Subtitle (big)', type: 'text'},
    ]}/>;
};
